<template lang="html">
    <select
	class="form-control"
	v-bind:value="value"
	v-on:input="$emit('input', $event.target.value)"
	v-bind:id="label + 'Select'"
	v-bind:class="{
		'deactive': disabled,
	}"
	v-bind:name="label + 'Select'">
		<option v-if="defaultOption" value="">
			Please select a {{ label || 'option'}}.
		</option>
		<option
		v-for="(option, index) in options"
		v-bind:key="index"
		v-bind:value="(valueKey ? option[valueKey] : option)">
			{{ option[labelKey] }}
		</option>
	</select>
</template>

<script>
export default {
  props: [
    "disabled",
    "options",
    "labelKey",
    "valueKey",
    "label",
    "input",
    "value",
    "defaultOption"
  ],
  created() {
	  console.log('select', this.defaultOption);
  }
};
</script>

<style lang="css" scoped>
</style>
